import React from 'react';
import Comments from '../Comments';
import BlogSectionNav from './BlogSectionNav';

/** تأیید/رد و پاسخ رسمی دیدگاه‌های مقالات؛ همان صفحهٔ نظرات، محدود به مقالات */
const BlogComments: React.FC = () => (
  <div>
    <BlogSectionNav
      title="دیدگاه‌های وبلاگ"
      description="دیدگاه‌ها پس از تأیید در صفحهٔ مقاله نمایش داده می‌شوند؛ پاسخ شما با نشان «پاسخ رسمی / تیم من حقیقی» زیر دیدگاه کاربر منتشر می‌شود."
    />
    <Comments fixedTargetType="ARTICLE" embedded />
  </div>
);

export default BlogComments;
